import { Injectable } from '@angular/core';
import { Message } from '../utils/Message';
import { ChangeEvent } from '../events/ChangeEvent';
import { GlobalEventEmitterService } from './global-event-emitter.service';
import { timer, Observable, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  flashvars:any;
  connection: WebSocket; 
  private lastUpdate:number = -1;
  private sender:string = null;
  private subscribe:Subscription;
  
  setSender( sender:string):void{
    this.sender = sender;
  }

  constructor() { }

  close():void{
    this.connection.close();
  }

  send(msg:string){
    this.connection.send(msg);
  }
  sendMsg(msg:Message):void{
    this.send(JSON.stringify(msg));
  }

  constructWSAdress(){
    let domain = this.flashvars.address;
    let protocol = this.flashvars.webProtocol;
    let port:number = this.flashvars.httpport;

    let wsUrl = "";
    if( protocol == "https"){ 
      wsUrl += "wss"
    }else{
      wsUrl += "ws"
    }
    wsUrl += "://";
    wsUrl += domain;
    wsUrl += ":";
    wsUrl += port;
    wsUrl += "/websocket";

    return wsUrl;
  }
  ngOnInit(flashvars:any) {
    this.flashvars = flashvars;
    console.log("Init socket");
    let wsDomain:string = this.constructWSAdress();
    console.log("Init socket with url: " + wsDomain);
    this.connection = new WebSocket(wsDomain);

    let T = this;
    this.connection.onopen = function(){
      console.log("onopen");
      T.onOpen();
    };
    this.connection.onerror = function(){
      console.log("onerror");
      T.onError();
    }
    this.connection.onmessage = function(event){
      console.log("onmessage");
      T.onMessage(event);
    }
    this.connection.onclose = function(){
      console.log("onclose");
      T.onClose();
    }
    console.log("Init socket finished");
  }

  isConnected():boolean{
    return WebSocket.OPEN == this.connection.readyState;
  }
  onOpen():void{
    console.error("connection state: " + this.connection.readyState);
    this.sendLogin();
  }
  onError():void{

  }
  onMessage(event:any):void{
    console.log(event.data);
    this.lastUpdate = new Date().getTime();

    let m:Message = JSON.parse(event.data);
    if (m.name == "hbMessage") {
      return;
    }
    if (m.name == "desynchroCommand") {
      throw new Error(m.params[0]);
    }else{
      GlobalEventEmitterService.globalEmitter.emit(new ChangeEvent("changeEvent", m ));
    }
  }
  onClose():void{
    if( this.subscribe != null ){
      this.subscribe.unsubscribe();
    }
    let e:Error = new Error("Connection to server closed. Please refresh game.");
    e.name = "Connection closed";
    throw e;
  }

  private sendLogin():void{
    console.log( "Send login: " + this.flashvars);
    /*
    let msg:Message = new Message();
    msg.fromServer = false;
    msg.name = "login";
    msg.params.push(this.flashvars.login);
    msg.params[1] = this.flashvars.newPostponedToken;
    msg.receiver = "server";
    msg.sender = this.flashvars.login;
    this.sendMsg(msg);
    */

    var msg:Message = new Message();
    msg.fromServer = false;
    msg.name = "sendLogin";
    msg.params = new Array();
    msg.params[0] = this.flashvars.login;
    msg.params[1] = this.flashvars.newPostponedToken
    msg.receiver = "";
    msg.sender = "";
    let e:ChangeEvent = new ChangeEvent("changeEvent", msg);
    GlobalEventEmitterService.globalEmitter.emit(e);

    this.startHB();
  }

  startHB() : void {
    let source:Observable<number> = timer(1500, 1500);
    this.subscribe = source.subscribe(  (val) => this.hbHandler());
  }

  private hbHandler():void {
    if (this.sender == null) {
      return;
    }
    let diff:number = new Date().getTime() - (this.lastUpdate + 1000 * 1000);
    if (this.lastUpdate != -1 && new Date().getTime() > this.lastUpdate + 1000 * 1000) {
      if( this.subscribe != null ){
        this.subscribe.unsubscribe();
      }
      throw new Error("Loose connection detected. Diff: " + diff);
    }else{				
      var hbMessage:Message = new Message();
      hbMessage.fromServer = false;
      hbMessage.name = "hbMessage";
      hbMessage.params = new Array();
      hbMessage.params[0] = "hbMessage";
      hbMessage.receiver = "server";
      hbMessage.sender = this.sender;
      this.sendMsg(hbMessage);
    }
  }
}
